import * as React from 'react';
import { RiErrorWarningFill } from 'react-icons/ri';
import { Flex, Tooltip, Typography } from '@ghq-abi/design-system-v2';

import { useClickableTooltip } from '~/shared/hooks';

import { ClickableTooltipTrigger } from '../ClickableTooltipTrigger';

type ErrorTooltipProps = {
  title: string;
  message: string;
  align?: 'center' | 'end' | 'start';
  iconSize?: number;
  buttonClassName?: string;
};

export function ErrorTooltip({
  title,
  message,
  align = 'end',
  iconSize = 18,
  buttonClassName = ''
}: ErrorTooltipProps) {
  const { rootTooltipProps, openTooltip } = useClickableTooltip();

  const alignClasses = {
    start: 'items-start text-left',
    center: 'items-center text-center',
    end: 'items-end text-right'
  };

  return (
    <Tooltip.Provider>
      <Tooltip.Root {...rootTooltipProps}>
        <Tooltip.Trigger asChild>
          <ClickableTooltipTrigger
            onClick={openTooltip}
            onTouchEnd={e => e.stopPropagation()}
            className={`ml-2 ${buttonClassName}`}>
            <RiErrorWarningFill size={iconSize} className="text-gray-700" />
          </ClickableTooltipTrigger>
        </Tooltip.Trigger>
        <Tooltip.Content>
          <Flex
            direction="column"
            className={`gap-4 w-48 ${alignClasses[align]}`}>
            <Typography
              as="strong"
              variant="body-sm-bold"
              className="text-white">
              {title}
            </Typography>
            <Typography
              variant="metadata-xs-regular"
              className="text-white mb-3">
              {message}
            </Typography>
          </Flex>
        </Tooltip.Content>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}
